const Org = Object.freeze({
  INSTALAB: 'instalab',
  PREMIER: 'premier',
})

export default Org